<template>
	<div class="m-grid__item m-grid__item--fluid m-wrapper user-info">
		<div class="m-content">
			<div class="row">
				<div class="col-xl-4 col-md-6">
					<div class="m-portlet">
						<div class="m-portlet__head">
							<div class="m-portlet__head-caption">
								<div class="m-portlet__head-title">
									<h3 class="m-portlet__head-text">
										Thông tin
									</h3>
								</div>
							</div>
						</div>
						<div class="m-portlet__body">
							<div class="m-widget12">
								<div class="m-widget12__item">
									<span class="m-widget12__text1">Tín dụng được cấp<br><span>{{this.budget}}</span></span>
									<span class="m-widget12__text2">Username<br><span>{{this.user.username}}</span></span>
								</div>
								<div class="m-widget12__item">
									<span class="m-widget12__text1">Đã dùng<br><span>{{this.usedBudget}}</span></span>
									<span class="m-widget12__text2">Cấp độ<br><span>{{this.user.role}}</span></span>
								</div>
								<div class="m-widget12__item">
									<span class="m-widget12__text1">Còn lại<br><span>{{this.remainBudget}}</span></span>
									<span class="m-widget12__text2">Lần đăng nhập cuối<br><span>{{this.lastLogin}}</span></span>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-xl-8 col-md-6">
					<div class="m-portlet">
						<div class="m-portlet__head">
							<div class="m-portlet__head-caption">
								<div class="m-portlet__head-title">
									<h3 class="m-portlet__head-text">
										Cấu hình
									</h3>
								</div>
							</div>
							<div class="m-portlet__head-tools">
								<div class="input-group">
									<div class="input-group-prepend">
										<span class="input-group-text">Hệ</span>
									</div>
									<select class="form-control" v-model="currentClass">
										<option v-for="(k,v) in this.user.class" :value="k">{{v}}</option>
									</select>
								</div>
							</div>
						</div>
						<div class="m-portlet__body">
							<div class="accordion-config">
								<table class="table table-config">
									<thead>
										<tr>
											<th rowspan="2">Giới hạn</th>
											<th colspan="5">2D</th>
											<th colspan="3">3D</th>
											<th colspan="2">4D</th>
										</tr>
										<tr>
											<th>Đầu đuôi</th>
											<th>7 lô</th>
											<th>Bao lô</th>
											<th>Đá thẳng</th>
											<th>Đá Xiên</th>
											<th>Đầu đuôi</th>
											<th>7 lô</th>
											<th>Bao lô</th>
											<th>Đuôi</th>
											<th>Bao lô</th>
										</tr>
									</thead>
									<tbody>
										<tr>
											<th scope="row">Bắc</th>
											<td v-for="config in bac">{{config.limit}}</td>
										</tr>
										<tr>
											<th scope="row">Trung</th>
											<td v-for="config in trung">{{config.limit}}</td>
										</tr>
										<tr>
											<th scope="row">Nam</th>
											<td v-for="config in nam">{{config.limit}}</td>
										</tr>
									</tbody>
								</table>
								<div class="m-separator m-separator--space m-separator--dashed"></div>
								<table class="table table-config">
									<thead>
										<tr>
											<th rowspan="2">Cài đặt hệ</th>
											<th colspan="2">Bắc</th>
											<th colspan="2">Trung</th>
											<th colspan="2">Nam</th>
										</tr>
										<tr>
											<th>Cò</th>
											<th>Trúng</th>
											<th>Cò</th>
											<th>Trúng</th>
											<th>Cò</th>
											<th>Trúng</th>
										</tr>
									</thead>
									<tbody>
										<tr>
											<th scope="row">2D</th>
											<td v-for="config in d2">{{config.value}}</td>
										</tr>
										<tr>
											<th scope="row">3D</th>
											<td v-for="config in d3">{{config.value}}</td>
										</tr>
										<tr>
											<th scope="row">4D</th>
											<td v-for="config in d4">{{config.value}}</td>
										</tr>
										<tr>
											<th scope="row">Đá thẳng</th>
											<td v-for="config in dt">{{config.value}}</td>
										<tr>
											<th scope="row">Đá Xiên</th>
											<td v-for="config in dx">{{config.value}}</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex';
	import { Utilities } from "../utilities";
	import GameConfig from "../components/GameConfig";
	import moment from 'moment';

	moment.locale('vi');

    export default {
		data() {
            return {
				xien: [],
				nam: [],
				bac: [],
				trung:[],
				d2:[],
				d3:[],
				d4:[],
				dt:[],
				dx:[],
				currentClass: null
            }
        },

        watch: {
        	currentClass: function(cls){
        		this.getConfig(cls, this.user);
        	},
        	user: function(u){
        		if(this.currentClass == null) this.currentClass = u.class[Object.keys(u.class)[0]];
        	}
        },

        created: function(){
        	if(this.user.code != undefined){
        		this.currentClass = this.user.class[Object.keys(this.user.class)[0]];
        	}
        },

        components: {
        	'game-config': GameConfig
        },

        computed: {
			...mapGetters({
				user: 'user',
		  		userBudget: 'userBudget',
		  		gameInfo: 'gameInfo'
			}),

			budget(){
				return this.userBudget.budget ? Utilities.formatNumber(this.userBudget.budget) : 0;
			},

			usedBudget(){
				return this.userBudget.budget ? Utilities.formatNumber(this.userBudget.budget - this.userBudget.remain) : 0;
			},

			remainBudget(){
				return this.userBudget.remain ? Utilities.formatNumber(this.userBudget.remain) : 0;
			},

			lastLogin(){
				return moment(this.user.last_login).format("DD MMM, YYYY");
			}
		},

        methods: {
			getConfig: async function(currentClass, user = null){
				let vm = this;
				if(!currentClass) currentClass = this.currentClass;
				if(currentClass == null) return;
				if(user == null) user = this.user;
				if(!user) return;

				let config = await axios.get("/admin-panel/user-info/config?class=" + currentClass + "&code=" + user.code);
	            let data = config.data.data;
	            var bac = [];
				var nam = [];
				var trung = [];
				for(let i in data){
					var c = data[i];
					switch(c.game_id){
						case 1://bac
							switch(c.prop_id){
								case 1: 
									bac.push({limit: c.limit_day, order: 1});//dauduoi
									break;
								case 4: 
									bac.push({limit: "", order: 2});//7lo
									bac.push({limit: c.limit_day, order: 3});//baolo
									break;
								case 14: 
									bac.push({limit: c.limit_day, order: 4});//dathang
									bac.push({limit: "", order: 5});//daxien
									break;
								case 6: 
									bac.push({limit: c.limit_day, order: 6});//3d-dauduoi
									break;
								case 9: 
									bac.push({limit: "", order: 7});//7lo
									bac.push({limit: c.limit_day, order: 8});//3d-dauduoi
									break;
								case 11: 
									bac.push({limit: c.limit_day, order: 9});//3d-dauduoi
									break;
								case 12: 
									bac.push({limit: c.limit_day, order: 10});//3d-dauduoi
									break;
							}
							break;
						case 2://nam
							switch(c.prop_id){
								case 1: 
									nam.push({limit: c.limit_day, order: 1});//dauduoi
									break;
								case 3: 
									nam.push({limit: c.limit_day, order: 2});//7lo
									break;
								case 5:
									nam.push({limit: c.limit_day, order: 3});//baolo
									break;
								case 14: 
									nam.push({limit: c.limit_day, order: 4});//dathang
									nam.push({limit: data[data.findIndex(el => (el.game_id === 3 && el.prop_id === 17))].limit_day, order: 5});//daxien
									break;
								case 6: 
									nam.push({limit: c.limit_day, order: 6});//3d-dauduoi
									break;
								case 8: 
									nam.push({limit: c.limit_day, order: 7});//3d-7lo
									break;
								case 10:
									nam.push({limit: c.limit_day, order: 8});//3d-baolo
									break;
								case 11: 
									nam.push({limit: c.limit_day, order: 9});//4d-dauduoi
									break;
								case 13: 
									nam.push({limit: c.limit_day, order: 10});//4d-baolo
									break;
							}
							break;
						case 4://trung
							switch(c.prop_id){
								case 1: 
									trung.push({limit: c.limit_day, order: 1});//dauduoi
									break;
								case 3: 
									trung.push({limit: c.limit_day, order: 2});//7lo
									break;
								case 5:
									trung.push({limit: c.limit_day, order: 3});//baolo
									break;
								case 14: 
									trung.push({limit: c.limit_day, order: 4});//dathang
									trung.push({limit: "", order: 5});//daxien
									break;
								case 6: 
									trung.push({limit: c.limit_day, order: 6});//3d-dauduoi
									break;
								case 8: 
									trung.push({limit: c.limit_day, order: 7});//3d-dauduoi
									break;
								case 10:
									trung.push({limit: c.limit_day, order: 8});//3d-dauduoi
									break;
								case 11: 
									trung.push({limit: c.limit_day, order: 9});//3d-dauduoi
									break;
								case 13: 
									trung.push({limit: c.limit_day, order: 10});//3d-dauduoi
									break;
							}
							break;
					}
				}

				bac = bac.sort((a,b) => {return a.order - b.order});
				nam = nam.sort((a,b) => {return a.order - b.order});
				trung = trung.sort((a,b) => {return a.order - b.order});

				var d2 = [];
				var d3 = [];
				var d4 = [];
				var dt = [];
				var dx = [];
				for(let i in data){
					var c = data[i];
					switch(c.game_id){
						case 1:
							switch(c.prop_id){
								case 1:
									d2.push({value: c.commission, sort: 1});
									d2.push({value: c.rate, sort: 2});
									break;
								case 6:
									d3.push({value: c.commission, sort: 1});
									d3.push({value: c.rate, sort: 2});
									break;
								case 11:
									d4.push({value: c.commission, sort: 1});
									d4.push({value: c.rate, sort: 2});
									break;
								case 14:
									dt.push({value: c.commission, sort: 1});
									dt.push({value: c.rate, sort: 2});
									break;
							}
						break;
						case 4:
							switch(c.prop_id){
								case 1:
									d2.push({value: c.commission, sort: 3});
									d2.push({value: c.rate, sort: 4});
									break;
								case 6:
									d3.push({value: c.commission, sort: 3});
									d3.push({value: c.rate, sort: 4});
									break;
								case 11:
									d4.push({value: c.commission, sort: 3});
									d4.push({value: c.rate, sort: 4});
									break;
								case 14:
									dt.push({value: c.commission, sort: 3});
									dt.push({value: c.rate, sort: 4});
									break;
							}
						break;
						case 2:
							switch(c.prop_id){
								case 1:
									d2.push({value: c.commission, sort: 5});
									d2.push({value: c.rate, sort: 6});
									break;
								case 6:
									d3.push({value: c.commission, sort: 5});
									d3.push({value: c.rate, sort: 6});
									break;
								case 11:
									d4.push({value: c.commission, sort: 5});
									d4.push({value: c.rate, sort: 6});
									break;
								case 14:
									dt.push({value: c.commission, sort: 5});
									dt.push({value: c.rate, sort: 6});
									break;
							}
						break;
					}
				}

				dx.push({value: "", sort: 1});
				dx.push({value: "", sort: 2});
				dx.push({value: "", sort: 3});
				dx.push({value: "", sort: 4});
				dx.push({value: data[data.findIndex(el => (el.game_id === 3 && el.prop_id === 17))].commission, sort: 5});
				dx.push({value: data[data.findIndex(el => (el.game_id === 3 && el.prop_id === 17))].rate, sort: 6});

				d2 = d2.sort((a,b) => {return a.order - b.order});
				d3 = d3.sort((a,b) => {return a.order - b.order});
				d4 = d4.sort((a,b) => {return a.order - b.order});
				dt = dt.sort((a,b) => {return a.order - b.order});
				dx = dx.sort((a,b) => {return a.order - b.order});
	            // config = config.data.data.map(e => { 
	            // 	e.prop = vm.gameInfo.props[e.prop_id].replace(/\s+/g, ''); return e; 
	            // });

	            // let xien = config.filter(c => {
	            // 	return c.game_id == 3;
	            // });

	            // let nam = config.filter(c => { return c.game_id == 2; }).sort((a,b) => {return a.prop_id - b.prop_id});
	            // let bac = config.filter(c => { return c.game_id == 1; }).sort((a,b) => {return a.prop_id - b.prop_id});
	            // let trung = config.filter(c => { return c.game_id == 4; }).sort((a,b) => {return a.prop_id - b.prop_id});

	            // this.xien = xien;
	            this.nam = nam;
	            this.bac = bac;
	            this.trung = trung;
	            this.d2 = d2;
	            this.d3 = d3;
	            this.d4 = d4;
	            this.dt = dt;
	            this.dx = dx;
			},
		}
	}
</script>

<style>
    /*.error {
		text-align: center;
		color: red;
		font-size: medium;
    }
    .alert.suspend{
	    width: 100% !important;
	    text-align: center;
	    font-weight: bold !important;
	    font-size: 15px !important;
    }
    .classs{
    	width: 65px;
    }*/
    .m-body .m-grid__item.m-grid__item--fluid.m-wrapper.user-info {
	    padding: 0px 20px;
	}
    .user-info .m-portlet {
	    -webkit-box-shadow: 0px 1px 15px 1px rgba(81,77,92,0.08) ;
	    box-shadow: 0px 1px 15px 1px rgba(81,77,92,0.08) ;
	    background-color: #fff
	}
	.user-info .m-portlet .m-portlet__head {
	    border-bottom: 1px solid #ebedf2;
	}
	.user-info .m-portlet .m-portlet__body {
	    padding: 2.2rem 2.2rem;
	}

	.m-accordion .m-accordion__item .m-accordion__item-body .m-accordion__item-content.accordion-config{
		padding: 0px;
	}
	.accordion-config .nav.nav.nav-tabs{
		margin-bottom: 0px;
	}
	.accordion-config .nav.nav-tabs .nav-link.active{
		background-color: #f4f3f8;
	}
	.accordion-config .nav-tabs .nav-link.active{
		border-color: #f4f3f8;
	}
	.table-config.table{
		text-align: center;
	}
	.table-config.table thead{
		background: #f4f3f8;
	}
	.table-config.table thead tr:first-child th{
		border-bottom: 1px solid #e9ebf3;
    vertical-align: middle;
	}
	.table-config.table thead th{
    	border-left: 1px solid #e9ebf3;
    	font-weight: 600;
	}
</style>